export default __webpack_public_path__ + "static/media/pet_attend_horizontal.e537fb43.png";